import React, { useEffect, useRef, useState } from "react";
import styles from './index.module.css';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { save3Ds } from "../../../redux/features/webx/webxService";

const WebXPaySubscription = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const user = useSelector((state) => state.auth.userDetails.details);
    const html3ds = useSelector((state) => state.webx.html3ds);
    const generateSessionRef = useRef(null);
    const [isReady, setIsReady] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        // Dynamically load PaymentSession script
        window.scrollTo(0, 0);
        const script = document.createElement("script");
        script.src =
            "https://cbcmpgs.gateway.mastercard.com/form/version/63/merchant/TESTWEBXPATOKLKR/session.js";
        script.async = true;

        script.onload = () => {
            // Hosted session init function
            WebxpayTokenizeInit({
                card: {
                    number: "#card-number",
                    securityCode: "#security-code",
                    expiryMonth: "#expiry-month",
                    expiryYear: "#expiry-year",
                    nameOnCard: "#cardholder-name",
                },
                ready: (generateSession) => {
                    generateSessionRef.current = generateSession;
                    setIsReady(true);
                },
                dispatch,
                setErrors,
                user,
                subscriptionId: id,
                setIsReady
            });
            window.scrollTo(0, 0);
        };

        script.onerror = () =>
            console.error("❌ Failed to load PaymentSession script");

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        document.body.style.overflowY = 'scroll'; // Always show vertical scrollbar
    }, []);

    // Handle payment submission
    const handleSaveCard = () => {
        // if (validateFields()) {
        setErrors({});
        if (!generateSessionRef.current) {
            console.error("❌ Webxpay not ready yet.");
            return;
        }

        generateSessionRef.current(
            (sessionId) => {
                if (window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage(sessionId);
                }

                alert(`Card tokenized: ${sessionId}`);
            },
            (error) => {
                console.error("❌ Session error:", error);

                if (error.type === "fields_in_error") {
                    setErrors(error.details);
                } else if (error.type === "system_error") {
                    setErrors({ general: error.details });
                } else if (error.type === "request_timeout") {
                    setErrors({ general: error.details });
                }
            }
        );
        // }
    };

    return (
        <div className={`main-container`}>
            <div className={`container-content ${styles.imageContainer}`}>
                <div className={styles.container}>
                    <div className={styles.card}>
                        <div className={styles.cardHeader}>
                            <div className={`${styles.lead} ${styles.fontWeightBold} ${styles.small}`}>
                                Please enter your card Information
                            </div>
                        </div>
                        <div className={styles.cardBody}>
                            <div className={styles.newCardWrapper}>
                                <div className={styles.formGroup}>
                                    <label className={styles.label}>Card Holder Name</label>
                                    <input
                                        type="text"
                                        id="cardholder-name"
                                        className={styles.formControl}
                                        readOnly
                                        placeholder="Ex: John De Silva"
                                    />
                                    {errors.cardHolder && (
                                        <span className={styles.textDanger}>{errors.cardHolder}</span>
                                    )}
                                </div>
                                <div className={styles.formGroup}>
                                    <label className={styles.label}>Card Number</label>
                                    <input
                                        type="text"
                                        id="card-number"
                                        className={styles.formControl}
                                        title="card number"
                                        readOnly
                                        placeholder="0000 0000 0000 0000"
                                    />
                                    <span className={styles.textDanger}>
                                        {errors.cardNumber === "missing" && "Enter valid card number"}
                                        {errors.cardNumber === "invalid" && "Invalid card number"}
                                    </span>
                                </div>
                                <div className={styles.formRow}>
                                    <div className={styles.formGroup}>
                                        <label className={styles.label}>Expiry Month</label>
                                        <input
                                            type="text"
                                            id="expiry-month"
                                            className={styles.formControl}
                                            readOnly
                                            placeholder="00"
                                        />
                                        <span className={styles.textDanger}>
                                            {errors.expiryMonth === "missing" && "Enter expiration month"}
                                            {errors.expiryMonth === "invalid" && "Invalid expiration month"}
                                        </span>
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label className={styles.label}>Expiry Year</label>
                                        <input
                                            type="text"
                                            id="expiry-year"
                                            className={styles.formControl}
                                            readOnly
                                            placeholder="00"
                                        />
                                        <span className={styles.textDanger}>
                                            {errors.expiryYear === "missing" && "Enter expiration year"}
                                            {errors.expiryYear === "invalid" && "Invalid expiration year"}
                                        </span>
                                    </div>
                                </div>
                                <div className={styles.formGroup}>
                                    <label className={styles.label}>CVV</label>
                                    <input
                                        type="text"
                                        id="security-code"
                                        className={styles.formControl}
                                        readOnly
                                        placeholder="000"
                                    />
                                    <span className={styles.textDanger}>
                                        {errors.securityCode === "missing" && "Enter CVV"}
                                        {errors.securityCode === "invalid" && "Invalid CVV"}
                                    </span>
                                </div>
                                {errors.general && (
                                    <div className={`${styles.generalError} ${styles.textDanger}`}>
                                        {errors.general}
                                    </div>
                                )}
                                <div className={`${styles.formGroup} ${styles.m0} ${styles.textRight}`}>
                                    <button
                                        className={`${styles.btn} ${styles.btnPrimary} ${styles.btnSm}`}
                                        onClick={handleSaveCard}
                                        disabled={!isReady}
                                    >
                                        {isReady ? "Submit" : "Loading..."}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default WebXPaySubscription;
/**
 * Hosted Session initialization (Webxpay function)
 */
function WebxpayTokenizeInit({ card, ready, dispatch, setErrors, user, subscriptionId, setIsReady }) {
    if (!window.PaymentSession) {
        console.error("❌ PaymentSession not loaded.");
        return;
    }

    function generateSession(successCallback, errorCallback) {
        window.PaymentSession.updateSessionFromForm("card", (response) => {
            if (response.status === "ok") {
                successCallback(response.session.id);
            } else {
                errorCallback({
                    type: response.status,
                    details: response.errors || response.errorMessage,
                });
            }
        });
    }

    window.PaymentSession.configure({
        fields: {
            card: {
                number: card.number,
                securityCode: card.securityCode,
                expiryMonth: card.expiryMonth,
                expiryYear: card.expiryYear,
                nameOnCard: card.nameOnCard,
            },
        },
        frameEmbeddingMitigation: ["javascript"],
        callbacks: {
            initialized: () => {
                ready(generateSession);
            },
            formSessionUpdate: (response) => {
                setIsReady(false);
                if (response.status === "ok") {
                    const data = {
                        session: response?.session?.id,
                        currency: 'LKR',
                        bankMID: 'TESTWEBXPATOKLKR',
                        subscription_id: subscriptionId,
                        customer: {
                            id: user?.id,
                            email: user?.email,
                            firstName: user?.full_name,
                            lastName: 'mylottery',
                            contactNumber: user?.phone_number,
                            addressLineOne: '46/46, Green Lanka Building',
                            city: 'Colombo',
                            postalCode: '10300',
                            country: 'Sri Lanka',
                        },
                    };

                    dispatch(save3Ds(data))
                        .unwrap()
                        .then((res) => {
                            setIsReady(true);
                            const blob = new Blob([res.html3ds], { type: 'text/html' });
                            const url = URL.createObjectURL(blob);
                            window.location.href = url;  // replaces the current page with the 3DS HTML
                        })
                        .catch((err) => {
                            console.error("Save 3DS error:", err);
                            setIsReady(true);
                        });
                }
                if (response.status === "fields_in_error") {
                    setIsReady(true);
                    setErrors(response.errors);
                }
            }
        },
        interaction: {
            displayControl: {
                formatCard: "EMBOSSED",
                invalidFieldCharacters: "REJECT",
            },
        },
    });
}

